import InformesListContainer from './InformesListContainer';

export default InformesListContainer;
